import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import WorkspaceUrls from '../../../constants/private/urls/workspace/workspace.urls';
import { IWSContext, IWSInDTO } from '../../../models/workspace/workspace-model';
import { IOrganIn, IOrgContext } from '../../../models/organization/organization-model';
import { IUpdateWorkspaceRequestBody } from '../../http-models/workspace/workspace-request-model';

@Injectable()
export class WorkspaceApiService {
    constructor(private http: HttpClient) {}

    createNewWorkspace$(orgContext: IOrgContext, name: string) {
        const url = WorkspaceUrls.getCreateWorkspacePOSTUrl(orgContext);
        return this.http.post<{ organization: IOrganIn; workspace: IWSInDTO }>(url, {
            name: name,
        });
    }

    getWorkspaceMetadata$(wsContext: IWSContext) {
        const url = WorkspaceUrls.getWorkspaceGETUrl(wsContext);
        return this.http.get<IWSInDTO>(url);
    }

    public updateWSField$(wsContext: IWSContext, body: IUpdateWorkspaceRequestBody) {
        const url = WorkspaceUrls.getUpdateWSFieldsPUTUrl(wsContext);
        return this.http.put<IWSInDTO>(url, body);
    }

    public updateWSOrganDefaultIds$(wsContext: IWSContext) {
        const url = WorkspaceUrls.getUpdateWSOrganDefaultIdsPUTUrl(wsContext);
        return this.http.put<IWSInDTO>(url, {});
    }
}
